import axios from 'axios';
import config from 'config';

const deleteAuthorizationHeader = (_, headers) => {
  delete headers.common['Authorization'];
};

const COUNTRIES_TO_POI_COUNTRY_MODIFIER = {
  UK: 'GB',
};

const buildParametersForAddressSearch = ({
  text,
  postalCode,
  countryCode,
  coordinates,
  layers,
}) => {
  const baseParams = {
    layers,
    text,
    'boundary.country':
      COUNTRIES_TO_POI_COUNTRY_MODIFIER[countryCode] || countryCode,
  };

  const { latitude, longitude } = coordinates || {};

  if (coordinates) {
    if (!postalCode) {
      return {
        ...baseParams,
        'focus.point.lat': latitude,
        'focus.point.lon': longitude,
      };
    }

    return {
      ...baseParams,
      'focus.point.lat': latitude,
      'focus.point.lon': longitude,
      'boundary.circle.lat': latitude,
      'boundary.circle.lon': longitude,
      'boundary.circle.radius': 25,
    };
  }

  return baseParams;
};

class AddressApi {
  constructor({ apiUrl, parserUrl }) {
    this.apiUrl = apiUrl;
    this.parserUrl = parserUrl;
    this.instance = axios.create({
      baseURL: this.apiUrl,
    });

    this.parserInstance = axios.create({
      baseURL: this.parserUrl,
    });

    this.searchAddress = this.searchAddress.bind(this);
    this.searchVenue = this.searchVenue.bind(this);
    this.searchPostalCode = this.searchPostalCode.bind(this);
    this.parseAddressSearch = this.parseAddressSearch.bind(this);
  }

  searchPostalCode = ({ postalCode, countryCode }) => {
    return this.instance.get('search/structured', {
      params: {
        postalcode: postalCode,
        country: COUNTRIES_TO_POI_COUNTRY_MODIFIER[countryCode] || countryCode,
      },
      transformRequest: deleteAuthorizationHeader,
    });
  };

  searchVenue = ({ text, postalCode, countryCode, coordinates }) => {
    const params = buildParametersForAddressSearch({
      text,
      postalCode,
      countryCode,
      coordinates,
      layers: 'venue',
    });
    return this.instance.get('autocomplete', {
      params,
      transformRequest: deleteAuthorizationHeader,
    });
  };

  searchStructuredAddress = ({ params, postalCode, countryCode }) => {
    return this.instance.get('search/structured', {
      params: {
        ...params,
        postalcode: postalCode,
        country: countryCode,
      },
      transformRequest: deleteAuthorizationHeader,
    });
  };

  searchAddress = ({ text, postalCode, countryCode, coordinates }) => {
    const params = buildParametersForAddressSearch({
      text,
      postalCode,
      countryCode,
      coordinates,
      layers: 'street,address',
    });
    return this.instance.get('autocomplete', {
      params,
      transformRequest: deleteAuthorizationHeader,
    });
  };

  getAddressFromLocation = ({ latitude, longitude }) => {
    const params = {
      'point.lat': latitude,
      'point.lon': longitude,
      size: 1,
      layers: 'address,street',
    };

    return this.instance.get('reverse', {
      params,
      transformRequest: deleteAuthorizationHeader,
    });
  };

  parseAddressSearch = ({ text }) => {
    return this.parserInstance.get('parse', {
      params: {
        address: text,
      },
      transformRequest: deleteAuthorizationHeader,
    });
  };
}

export default new AddressApi({
  apiUrl: config.POI_ADDRESS_URL,
  parserUrl: config.POI_ADDRESS_PARSER_URL,
});
export { buildParametersForAddressSearch };
